import React from "react";

function TrafficHomeOne({ className }) {
  return (
    <section className={`appie-service-area pt-140 pb-180 ${className || ""}`}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="appie-traffic-title">
              <h3 className="title">Badminton Rules and Regulations</h3>
              <h3>Playing Conditions</h3>
              <p>a. Common Rules</p>
              <p>• Shuttle used would be - Yonex AS 2 Feather Shuttles</p>
              <p>
                • Each team can have a maximum of 6 players, consisting of 3
                males and 3 females.
              </p>{" "}
              <p>
                • The match formats include Men's Singles, Women's Singles,
                Men's Doubles, and Women's Doubles.
              </p>{" "}
              <p>
                • Mixed teams, comprising both male and female players, are
                allowed.
              </p>
              <p>• League matches would be of 3 Sets of 11 Points each</p>
              <p>• Knockout matches would be of 5 sets of 11 points each</p>
              <ul>
                <li>• Only Non-marking shoes are allowed</li>
              </ul>
              <p>
                • A player must wait until his opponent is ready before serving.
                If the opponent attempts a return then he is ruled having been
                ready.
              </p>
              <p>
                • Partner once played cannot be changed in any condition
                whatsoever
              </p>
              <p>
                • At 10 all, the side which gains a 2 point lead first, wins
                that game. wins that game &amp; there will be Golden Point rule
                at 14 all
              </p>
              <p>• The side winning a game serves first in the next game.</p>
              <ul>
                <li>• All other BWF rules shall apply</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TrafficHomeOne;
